import { useState } from "react";

import { Col, Divider, Row } from "antd";
import { t } from "i18next";
import PropTypes from "prop-types";

import useDetailsByDeviceId from "../../../../../api/hooks/useDetailsByDeviceId";
import useZoneDelete from "../../../../../api/hooks/useZoneDelete";
import DeleteWarning from "../../../../Shared/DeleteWarning";

import "../scss/ZoneManagement.scss";

function ZoneCard({
  zone,
  setIsNewZoneModalOpen,
  setCurrentZone,
  refetchZones,
}) {
  const [isAlertDeleteOpen, setAlertDeleteOpen] = useState(false);
  const [shouldFetchDetails, setShouldFetchDetails] = useState(false);

  const { data: deviceDetails } = useDetailsByDeviceId(zone?.ZoneUniqueId, {
    enabled: shouldFetchDetails,
  });

  const { mutate: deleteZone } = useZoneDelete();

  const handleDeleteZone = () => {
    setShouldFetchDetails(true);
    setAlertDeleteOpen(true);
  };

  const handleConfirmDelete = () => {
    deleteZone(deviceDetails?.Device?.Device?.SerialNumber);
    setAlertDeleteOpen(false);
    setShouldFetchDetails(false);
    refetchZones();
  };

  const handleCancelDelete = () => {
    setAlertDeleteOpen(false);
    setShouldFetchDetails(false); // Reset fetch flag to avoid fetching again unnecessarily
  };

  return (
    <>
      <div
        role="none"
        className="bg-triple-main-blue shadow-md overflow-hidden"
      >
        <Row className="h-full justify-between">
          {zone?.ZoneName ? (
            <Col
              className="self-center text-end"
              xs={{ span: 24 }}
              lg={{ span: 3 }}
            >
              <div className="my-4 mx-4">
                <div className="text-12 text-triple-white-new">
                  {zone?.ZoneName}
                </div>
              </div>
            </Col>
          ) : (
            <Col
              className="self-center text-end"
              xs={{ span: 24 }}
              lg={{ span: 3 }}
            >
              <div className="my-4 mx-4">
                <div className="text-12 text-triple-white-new">
                  {t("create_zone.zone_name_is_not_present")}
                </div>
              </div>
            </Col>
          )}
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-center"
            xs={{ span: 24 }}
            lg={{ span: 3 }}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {zone?.ZoneSystem}
              </div>
            </div>
          </Col>
          {zone?.Location ? (
            <>
              <Divider type="vertical" className="h-6 self-center" />
              <Col
                className="self-center text-center"
                xs={{ span: 24 }}
                lg={{ span: 3 }}
              >
                <div className="my-4 mx-4">
                  <div className="text-12 text-triple-white-new">
                    {zone?.Location}
                  </div>
                </div>
              </Col>
            </>
          ) : (
            <>
              <Divider type="vertical" className="h-6 self-center" />
              <Col
                className="self-center text-center"
                xs={{ span: 24 }}
                lg={{ span: 3 }}
              >
                <div className="my-4 mx-4">
                  <div className="text-12 text-triple-white-new">
                    {t("create_zone.zone_location_is_not_present")}
                  </div>
                </div>
              </Col>
            </>
          )}
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-center"
            xs={{ span: 24 }}
            lg={{ span: 3 }}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {zone?.DateCreation}
              </div>
            </div>
          </Col>
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-center cursor-pointer"
            xs={{ span: 24 }}
            lg={{ span: 1 }}
            onClick={() => {
              setCurrentZone(zone);
              setIsNewZoneModalOpen(!!zone);
            }}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {t("create_zone.edit")}
              </div>
            </div>
          </Col>
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-center"
            xs={{ span: 24 }}
            lg={{ span: 3 }}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {zone?.SwitchMatrix ? "yes" : "no"}
              </div>
            </div>
          </Col>
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-center cursor-pointer"
            xs={{ span: 24 }}
            lg={{ span: 1 }}
            onClick={() => {
              setCurrentZone(zone);
              setIsNewZoneModalOpen(!!zone);
            }}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {t("create_zone.edit")}
              </div>
            </div>
          </Col>
          <Divider type="vertical" className="h-6 self-center" />
          <Col
            className="self-center text-start cursor-pointer"
            xs={{ span: 24 }}
            lg={{ span: 2 }}
            onClick={handleDeleteZone}
          >
            <div className="my-4 mx-4">
              <div className="text-12 text-triple-white-new">
                {t("create_zone.delete")}
              </div>
            </div>
          </Col>
        </Row>
      </div>
      <DeleteWarning
        onDeleteClick={handleConfirmDelete}
        onCancelClick={handleCancelDelete}
        isAlertDeleteOpen={isAlertDeleteOpen}
      />
    </>
  );
}

ZoneCard.propTypes = {
  zone: PropTypes.object,
  setIsNewZoneModalOpen: PropTypes.any,
  setCurrentZone: PropTypes.func,
  refetchZones: PropTypes.func,
};

ZoneCard.defaultProps = {
  zone: {},
  setIsNewZoneModalOpen: () => {},
  setCurrentZone: () => {},
  refetchZones: () => {},
};
export default ZoneCard;
